<template>
  <div class="container">
    <div class="list-model-card" v-for="item in couponModelList">
      <i
        class="el-icon-error activeDelBtn"
        @click.stop="removeCouponModel(item)"
      ></i>
      <p>{{ item.modelName }}</p>
    </div>
    <el-card
      class="add-btn"
      shadow="never"
      body-style="padding: 0"
      @click.native="addHandler"
    >
      <i class="el-icon-plus"></i>
    </el-card>

    <el-dialog
      title="添加商品"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      v-loading="dialogLoading"
    >
      <el-select
        v-model="modelData"
        multiple
        filterable
        remote
        reserve-keyword
        placeholder="请输入型号名称"
        :remote-method="searchModel"
        :loading="modelLoading"
        style="width: 100%"
      >
        <el-option
          v-for="item in modelList"
          :key="item.modelId"
          :label="item.modelName"
          :value="item.modelId"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        style="margin-top: 20px;"
        @click="addNewCouponModel"
        >保存</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import inputTag from "./inputTag";
import {
  getCouponModelApi,
  saveCouponModelApi,
  delCouponModelApi
} from "@/api/coupon";
import { resonFaultGetModel } from "@/api/api";
export default {
  name: "couponModel",
  components: { inputTag },
  props: {
    couponId: {
      required: true,
      type: Number | String
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      modelLoading: false,
      couponModelList: [],
      modelList: [],
      modelData: []
    };
  },
  watch: {
    couponId: function(v) {
      if (v) {
        this.loadCouponModel();
      } else {
        this.couponModelList = [];
      }
    }
  },
  created() {},
  methods: {
    addHandler() {
      if (!this.couponId) {
        this.$message({
          message: "请先保存基础信息后在添加",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
    },
    loadCouponModel() {
      let _self = this;
      if (this.couponId) {
        getCouponModelApi(this.couponId).then(res => {
          if (res.data.status == 100) {
            _self.couponModelList = res.data.results;
          }
        });
      }
    },
    searchModel(query) {
      if (query !== "") {
        console.log(query);
        this.modelLoading = true;
        resonFaultGetModel({ modelName: query })
          .then(res => {
            if (res.data.status == 100) {
              this.modelList = res.data.results;
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            this.modelLoading = false;
          });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.modelData = [];
    },
    addNewCouponModel() {
      if (this.modelData && this.modelData.length > 0) {
        this.saveCouponModel();
      } else {
        this.$message({ message: "请确认需要添加的型号", type: "warning" });
      }
    },
    saveCouponModel() {
      let _self = this;
      if (this.modelData && this.modelData.length > 0 && this.couponId) {
        _self.dialogLoading = true;
        saveCouponModelApi(this.couponId, this.modelData)
          .then(res => {
            if (res.data.status == 100) {
              _self.loadCouponModel();
              _self.handleClose();
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            _self.dialogLoading = false;
          });
      }
    },
    removeCouponModel(item) {
      let _self = this;
      if (item && item.id) {
        this.$confirm(`是否删除当前型号${item.modelName}`, "提示", {
          type: "warning"
        })
          .then(() => {
            delCouponModelApi(item.id).then(res => {
              if (res.data.status == 100) {
                _self.loadCouponModel();
                _self.handleClose();
              } else {
                this.$message({ message: res.data.message, type: "warning" });
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="scss" type="text/css" scoped>
.container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.list-model-card {
  align-items: center;
  justify-content: center;
  display: flex;

  position: relative;
  width: 200px;
  height: 80px;
  margin: 0 20px;
  margin-top: 10px;
  border: 1px solid #c6c6c6;
  border-radius: 20px;
  padding: 10px;
  .activeDelBtn {
    display: none;
    position: absolute;
    top: 5px;
    left: 5px;
    color: #c41335;
  }
  &:hover .activeDelBtn {
    display: block;
  }
}
.add-btn {
  width: 50px;
  height: 50px;
  border: 1px dashed #c6c6c6;
  line-height: 50px;
  display: flex;
  justify-content: center;
  i {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// couponModel.vue?1d706e2d